import AppService from "./AppService";
import { LocaleService } from "./LocaleService";
import type { Language } from "./LocaleService";

/**
 * Paginas legales que se cargan desde gronze.com.
 */
export type ExternalPageName = 'legal_usage' | 'legal_privacy' | 'legal_cookies';

/**
 * Identificadores de nodo en gronze.com, por pagina, plataforma e idioma.
 *
 * La PWA y la app nativa apuntan a nodos distintos porque el texto legal no es
 * el mismo en los dos casos.
 */
const staticPageIDs: Record<ExternalPageName, Record<'pwa' | 'app', Record<Language, string>>> = {
    legal_usage: {
        pwa: {
            es: '1424',
            en: '35397',
        },
        app: {
            es: '31380',
            en: '35381',
        },
    },
    legal_privacy: {
        pwa: {
            es: '16620',
            en: '35398',
        },
        app: {
            es: '31381',
            en: '35380',
        },
    },
    legal_cookies: {
        pwa: {
            es: '2311',
            en: '35382',
        },
        app: {
            es: '2311',
            en: '35382',
        },
    }
};

/**
 * Pages loaded from gronze.com
 *
 * Vive fuera de Constants porque necesita AppService y LocaleService, y esa
 * dependencia metia a Constants —que por lo demas son constantes puras— dentro
 * del ciclo de importaciones de common.
 */
export const getExternalPages = (): Record<ExternalPageName, string> => {
    const isPwa = AppService.isPwa() ? 'pwa' : 'app';
    const lang = LocaleService.getLanguage();

    return {
        legal_usage: staticPageIDs['legal_usage'][isPwa][lang],
        legal_privacy: staticPageIDs['legal_privacy'][isPwa][lang],
        legal_cookies: staticPageIDs['legal_cookies'][isPwa][lang],
    }
}
